import supabaseClient from '@/api/supabaseClient';
import { SupabaseClient } from '@supabase/supabase-js';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface VerifyUserRequest {
  id: string;
  email: string;
  name: string;
}

const useVerifyUsers = () => {
  const client = supabaseClient;
  const queryClient = useQueryClient();

  const mutationFn = async (request: VerifyUserRequest) => {
    return verifyUser(client, request);
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['organizations', 'not-verified'] });
    },
  });
};

export default useVerifyUsers;

async function verifyUser(client: SupabaseClient, request: VerifyUserRequest): Promise<void> {
  const { error: verificationError } = await client
    .from('organizations')
    .update({ status: 'Active' })
    .eq('id', request.id);

  if (verificationError) throw new Error(verificationError.message);
}
